module.exports = __webpack_public_path__ + "static/media/22.878bb590.jpg";